<template lang="pug">
  v-autocomplete(
    :value="value"
    :items="items"
    :loading="isFetching"
    :error-messages="errorMessages"
    :disabled="disabled"
    :label="label"
    :search-input.sync="search"
    item-text="name"
    item-value="id"
    @input="args => $emit('input', args)"
    @focus="onFocus"
  )
</template>

<script>
  import API from '@/utils/API';
  import VSelect from 'vuetify/es5/components/VSelect/VSelect';

  export default {
    name: 'location-select',

    props: {
      value: { type: [Number, String] },
      errorMessages: { type: [Array, String], default: () => [] },
      label: { type: String },
      disabled: { type: Boolean, default: false },
      parentId: { type: [Number, String] },
    },

    data() {
      return {
        items: [],
        isFetching: false,
        search: null,
      };
    },

    methods: {
      async fetch(parentId) {
        try {
          this.items = [];
          this.isFetching = true;

          const results = await API.politicalDivisions(parentId);

          this.items = results;
        } catch (e) {
          return e;
        } finally {
          this.isFetching = false;
        }
      },

      onFocus() {
        this.search = '';

        this.$emit('focus');
      },
    },

    mounted() {
      if(!this.disabled) this.fetch(this.parentId);
    },

    components: { VSelect },

    watch: {
      parentId(newParentId) {
        if(!this.disabled) this.fetch(newParentId);
      },
    },
  };
</script>

